import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { TotalCropReportTable } from "../../../Common/Table/tableContent";
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { dailyHarvesterPerformancesReportSchema } from "../DailyHarvesterPerformancesReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import MaterialTable, { MTableBody } from "material-table";
import _, { flatMap } from 'lodash';
import $ from 'jquery';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Box from '@material-ui/core/Box';
import { Container } from '@material-ui/core';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import { Card } from '@material-ui/core';

const screenCode = 'DAILYHARVESTERPERFORMANCESREPORT'

export function DailyHarvesterPerformancesReport(props) {

    const componentRef = useRef();
    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%'
        },
        paper: {
            width: '100%',
        },
        table: {
            minWidth: 750
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    }));

    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [gangs, setGang] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        gangID: "0",
        month: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(dailyHarvesterPerformancesReportSchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState([]);
    const [isViewTable, setIsViewTable] = useState(true);
    const [columeNames, setColumeNames] = useState([]);
    const [allTotal, setAllTotal] = useState([]);
    const [total, setTotal] = useState(0);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const inishialColumName = [{
        title: 'Date', field: 'weightReadTime', render: rowData => rowData.weightReadTime, headerStyle: {
            color: '#000000',
            textAlign: 'center',
            fontWeight: 'bold'
        }, cellStyle: { textAlign: 'left' }

    }]
    const [contentRowNames, setContentRowNames] = useState([]);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        collectionID: "",
        gang: "",
        month: "",
    });

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, reportData.length - page * rowsPerPage);

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )
    }, [searchData.operationEntityID])

    useEffect(() => {
        trackPromise(
            getGangByCollectionPointID()
        )
    }, [searchData.collectionPointID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYHARVESTERPERFORMANCESREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    async function getGangByCollectionPointID() {
        const gang = await service.getGangByCollectionPointID(searchData.operationEntityID, searchData.collectionPointID);
        setGang(gang);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, dailyHarvesterPerformancesReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    async function handleSearch(e) {

        setIsTableHide(true);
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        setIsViewTable(true);
        const reportData = await service.GetDailyHarvesterPerformancesReport(searchData.operationEntityID, searchData.collectionPointID, searchData.gangID, searchData.month);

        let newRes = _.cloneDeep(reportData);
        var result = [];
        var totalRow = [];
        var totalOfAllrecords = 0;
        var initialcsvHeaders = [];
        initialcsvHeaders.push({ label: "Name", value: "firstName" });
        initialcsvHeaders.push({ label: "EPF", value: "epfNo" });

        newRes.forEach(x => {
            var date = x.cardReadTime.split('T')[0];

            var duplicateTotalRowData = totalRow.find(y => y.name === date);
            if (duplicateTotalRowData) {
                duplicateTotalRowData.value = duplicateTotalRowData.value + x.totalAmount;
            } else {
                totalRow.push({ name: date, value: x.totalAmount });
            }

            var duplicateDate = result.find(y => y.employeeID === x.employeeID);
            if (duplicateDate) {
                duplicateDate[date] = duplicateDate[date] == undefined ? 0 + x.totalAmount : duplicateDate[date] + x.totalAmount;
                duplicateDate.firstName = x.firstName;
                duplicateDate.epfNo = x.epfNo;
                duplicateDate.employeeID = x.employeeID;
                duplicateDate.employeeTypeID = x.employeeTypeID;
                duplicateDate.total = duplicateDate.total == undefined ? 0 + x.totalAmount : duplicateDate.total + x.totalAmount;
                duplicateDate.totalDays = duplicateDate.totalDays + 1;
                duplicateDate.configurationValue = x.configurationValue;
                totalOfAllrecords = totalOfAllrecords + x.totalAmount;
            }
            else {
                result.push({
                    [date]: x.totalAmount,
                    firstName: x.firstName,
                    epfNo: x.epfNo,
                    employeeID: x.employeeID,
                    employeeTypeID: x.employeeTypeID,
                    total: x.totalAmount,
                    totalDays: 1,
                    configurationValue: x.configurationValue
                });
                totalOfAllrecords = totalOfAllrecords + x.totalAmount;
            }


        });
        setTotal(totalOfAllrecords);
        setAllTotal(totalRow)
        setCsvData(result)
        setReportData(result)
        var year = searchData.month.split('-')[0]
        var month = searchData.month.split('-')[1]

        const daysInMonth = getDaysInMonth(parseInt(month), parseInt(year));
        const weekends = getWeekendsInMonth(parseInt(year), parseInt(month));

        var daysForColumn = [];

        for (var i = 0; i < daysInMonth; i++) {
            var dayLength = ((i + 1).toString()).length
            var createDate = (searchData.month + '-' + (dayLength == 1 ? ('0' + (i + 1)).toString() : (i + 1).toString()).toString())
            let duplicateDate = [];
            weekends.forEach(x => {
                let sd = x.toLocaleDateString().split("/");
                let final = sd[2] + "-" + sd[0].padStart(2, 0) + "-" + sd[1].padStart(2, 0);
                if (final === createDate) {
                    duplicateDate.push(x)
                }
            })
            var createColumColorCode = duplicateDate.length === 0 ? 0 : (duplicateDate.toString()).substring(0, 3) == "Sat" ? 1 : 2
            daysForColumn.push({
                column: createDate,
                columnColor: createColumColorCode,
                columnName: i + 1,
            });
            initialcsvHeaders.push({ label: 'day ' + (i + 1), value: createDate });
        }
        initialcsvHeaders.push({ label: "Total Kg", value: "total" });
        initialcsvHeaders.push({ label: "Total Days", value: "totalDays" });
        setColumeNames(daysForColumn)
        setCsvHeaders(initialcsvHeaders)
        setSelectedSearchData();
    }

    function getDaysInMonth(month, year) {
        return new Date(year, month, 0).getDate();
    }

    function getWeekendsInMonth(year, month) {
        const weekends = [];
        const firstDayOfMonth = new Date(year, month - 1, 1);
        const lastDayOfMonth = new Date(year, month, 0);
        for (let date = firstDayOfMonth; date <= lastDayOfMonth; date.setDate(date.getDate() + 1)) {
            if (date.getDay() === 0 || date.getDay() === 6) {
                weekends.push(new Date(date));
            }
        }
        return weekends;
    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: operationEntity[searchData.operationEntityID],
            collectionID: collectionPoint[searchData.collectionPointID],
            gang: gangs[searchData.gangID],
            month: searchData.month
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function createFile() {
        var settings = {
            sheetName: 'DailyHarvesterPerformances',
            fileName: 'Daily Harvester Performances Report',
            writeOptions: {}
        }
        let newColumeNames = _.cloneDeep(columeNames);
        let newAllTotal = _.cloneDeep(allTotal);

        const obj = newColumeNames.reduce((acc, cur) => {
            const value = reportData.filter(x => x[cur.column])
            acc[cur.column] = value.length == 0 ? "" : value.length;
            return acc;
        }, {});
        obj["firstName"] = "Plucker Count";

        const obj2 = newAllTotal.reduce((acc, cur) => {
            acc[cur.name] = cur.value
            return acc;
        }, {});
        obj2["firstName"] = "Total";
        obj2["total"] = parseInt(total);

        var newRow1 = {
            firstName: "Group : " + groups[searchData.groupID]
        }

        var newRow2 = {
            firstName: "Estate : " + operationEntity[searchData.operationEntityID]
        }

        var newRow3 = {
            firstName: searchData.collectionPointID == "0" ? "Division : All Division" : "Division : " + collectionPoint[searchData.collectionPointID]
        }

        var newRow4 = {
            firstName: searchData.gangID == "0" ? "Gang : All Gang" : "Gang : " + gangs[searchData.gangID]
        }

        var newRow5 = {
            firstName: "Month : " + searchData.month
        }

        csvData.push(obj, obj2, {}, {}, newRow1, newRow2, newRow3, newRow4, newRow5)
        xlsx(csvHeaders, csvData, settings, true)
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Daily Harvester Performances Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Division</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Division--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>

                            </div>
                            <div className="form-group row">
                                <div className="col-md-4 pb-1">
                                    <InputLabel shrink id="gangID">Gang</InputLabel>
                                    <Select
                                        fullWidth
                                        id="gangID"
                                        name="gangID"
                                        value={searchData.gangID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Gang--</MenuItem>
                                        {generateDropDownMenu(gangs)}
                                    </Select>
                                    {errors["gangID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["gangID"]}</FormHelperText>}
                                </div>
                                <div className="col-md-4 pb-1">
                                    <TextField
                                        id="month"
                                        label="month *"
                                        name="month"
                                        type="month"
                                        fullWidth
                                        value={searchData.month}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["month"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {reportData.length > 0 ?
                                <div className="form-group row">
                                    <div className="col-md-12 pb-1">
                                        <Container>
                                            <Card style={{ justifycontent: 'center' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer>
                                                        <Table className={classes.table}
                                                            aria-labelledby="tableTitle"
                                                            aria-label="enhanced table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell style={{ fontWeight: "bold" }} align='center'>Name</TableCell>
                                                                    <TableCell style={{ fontWeight: "bold" }} align='center'>EPF</TableCell>
                                                                    {columeNames.map((item) => (
                                                                        <TableCell style={{
                                                                            fontWeight: "bold", backgroundColor: item.columnColor == 0 ? null :
                                                                                item.columnColor == 1 ? '#6aa3d6' : '#E25c5a'
                                                                        }} align='center'>{item.columnName}</TableCell>
                                                                    ))}
                                                                    <TableCell style={{ fontWeight: "bold" }} align='center'>Total Kg</TableCell>
                                                                    <TableCell style={{ fontWeight: "bold" }} align='center'>Total Days</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    .map((row, index) => {
                                                                        return (
                                                                            <TableRow>
                                                                                <TableCell align='left'>{row.firstName}</TableCell>
                                                                                <TableCell align='center'>{row.epfNo}</TableCell>
                                                                                {columeNames.map((column) => {
                                                                                    const value = row[column.column];
                                                                                    return (
                                                                                        <TableCell style={{
                                                                                            backgroundColor: column.columnColor == 0 ? null :
                                                                                                column.columnColor == 1 ? '#6aa3d6' : '#E25c5a'
                                                                                        }} align='center'>
                                                                                            {value == undefined ? '-' :
                                                                                                row.employeeTypeID == 1 ?
                                                                                                    ((row.configurationValue > parseInt(value)) ?
                                                                                                        <Chip label={parseInt(value)} style={{ border: '2px solid' }} color="primary" variant="outlined" /> :
                                                                                                        parseInt(value)) :
                                                                                                    <Chip label={parseInt(value)} style={{ border: '2px solid' }} color="secondary" variant="outlined" />
                                                                                            }</TableCell>
                                                                                    );
                                                                                })}
                                                                                <TableCell style={{ fontWeight: "bold" }} align='center'>{row.total}</TableCell>
                                                                                <TableCell style={{ fontWeight: "bold" }} align='center'>{row.totalDays}</TableCell>
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                                <TableRow>
                                                                    <TableCell align='center' style={{ fontWeight: "bold" }} colSpan={2}>Plucker Count</TableCell>
                                                                    {columeNames.map((column) => {
                                                                        const value = reportData.filter(x => x[column.column])
                                                                        return (
                                                                            <TableCell style={{
                                                                                fontWeight: "bold", backgroundColor: column.columnColor == 0 ? null :
                                                                                    column.columnColor == 1 ? '#6aa3d6' : '#E25c5a'
                                                                            }} align='center'>{value.length == 0 ? '-' :
                                                                                parseInt(value.length)}</TableCell>
                                                                        );
                                                                    })}
                                                                    <TableCell style={{ fontWeight: "bold" }} align='center'>-</TableCell>
                                                                    <TableCell style={{ fontWeight: "bold" }} align='center'>-</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align='center' style={{ fontWeight: "bold" }} colSpan={2}>Total Kg</TableCell>
                                                                    {columeNames.map((column) => {
                                                                        const value = allTotal.find(x => x.name == column.column)
                                                                        return (
                                                                            <TableCell style={{
                                                                                fontWeight: "bold", backgroundColor: column.columnColor == 0 ? null :
                                                                                    column.columnColor == 1 ? '#6aa3d6' : '#E25c5a'
                                                                            }} align='center'>{value == undefined ? '-' :
                                                                                parseInt(value.value)}</TableCell>
                                                                        );
                                                                    })}
                                                                    <TableCell style={{ fontWeight: "bold" }} align='center'>{parseInt(total)}</TableCell>
                                                                    <TableCell style={{ fontWeight: "bold" }} align='center'>-</TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 50]}
                                                        component="div"
                                                        count={reportData.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={handleChangePage}
                                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                            </Card>
                                        </Container>
                                    </div>
                                </div> : null
                            }
                        </form>
                        {reportData.length > 0 ?
                            <div className="pt-3">
                                <ReactToPrint
                                    trigger={() => <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Create PDF"
                                    />}
                                    content={() => componentRef.current}
                                    documentTitle={'Daily Harvester Performances Report'}
                                />
                                <div hidden={true}>
                                    <CreatePDF ref={componentRef} reportData={reportData} columeNames={columeNames}
                                        selectedSearchValues={selectedSearchValues} allTotal={allTotal} total={total} />
                                </div>
                                <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="Excel"
                                    onClick={createFile}
                                />
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}



